
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import corpService from "@/store/common/module/CorpService";
import TariffGrid from "./TariffGrid.vue";
import TariffCreate from "./TariffCreate.vue";
import { Tariff } from "./TariffInterfaces";

enum Tabs {
  Grid,
  CreateEdit,
}

@Component({
  components: {
    TariffGrid,
    TariffCreate,
  },
  props: {
    value: {
      default: null,
    },
    readonly: {
      default: true,
    }
  },
})
export default class TariffManager extends Vue {
  @Prop({ default: null }) readonly client_id!: string | null;

  showDialog = false;
  selectedTariff: Tariff | null = null;
  currentTab = Tabs.Grid;
  selectedTariffId: string | null = null;

  handleTariffChange(tariff: any) {
    this.selectedTariff = tariff;
    this.$emit("input", this.selectedTariff);
    this.showDialog = false;
  }

  setVehicleCategoryName(_id: string): string {
    if (!_id) return "";
    const vehicleCategories = corpService.vehicleCategories;
    const vehicleCategorie = vehicleCategories.find(v => v._id === _id);
    return vehicleCategorie ? vehicleCategorie.name : "";
  }


  handleEdit(_id: string) {
    this.selectedTariffId = _id; // set the ID
    this.currentTab = Tabs.CreateEdit;
  }

  handleCreate() {
    this.selectedTariffId = null;
    this.currentTab = 1; // switch to the second tab
  }

  @Watch("client_id", { immediate: true })
  onClientIdChange(newId: string, oldId: string) {
    this.selectedTariff = null;
    this.selectedTariffId = null;
    this.currentTab = Tabs.Grid;
  }

  async mounted() {
    await corpService.populateVehicleCategories();
  }

}
